// src/components/common/AppModal/AppModal.tsx
import React from 'react';
import { Modal } from 'shared-portal-component';
import { useSelector } from 'react-redux';

import type { RootState } from '@/store';
import { selectShowLoader } from '@/store/selectors/ui';

 type ExternalModalProps = React.ComponentProps<typeof Modal>;

/**
 * Wrapper around design-system Modal that injects global showLoader flag.
 * Keeps individual modal components decoupled from Redux.
 */
const AppModal: React.FC<ExternalModalProps> = ({ ...rest }) => {
   const globalShowLoader = useSelector((state: RootState) => selectShowLoader(state));
  return <Modal {...rest} showLoader={globalShowLoader} />;
};

export default AppModal;
